import React from "react";
import "../../theme/custom-components/AppNotAvailable.css";
import playStoreBadge from "../../img/playstore.png";
import appStoreBadge from "../../img/appstore.svg";
import { UrlConstants } from "../Constants";

const AppNotAvailable: React.FC = () => {
  const iosAppUrl: string = UrlConstants.CMED_MOBILE_APP_STORE_LINK;
  const androidAppUrl: string = UrlConstants.CMED_MOBILE_GOOGLE_PLAY_STORE_LINK;

  return (
    <div className="container-app-not-available">
      <h1 className="header-app-not-available">
        CME Direct Mobile is Not Available on a Web Browser
      </h1>
      <p className="text-app-not-available">
        This application is designed for mobile devices only. Please download it
        from your favorite app store to continue.
      </p>
      <div className="badge-container-app-not-available">
        <a href={iosAppUrl} target="_blank" rel="noopener noreferrer">
          <img
            src={appStoreBadge}
            alt="Download on the App Store"
            className="app-store-badge-app-not-available"
          />
        </a>
        <a href={androidAppUrl} target="_blank" rel="noopener noreferrer">
          <img
            src={playStoreBadge}
            alt="Get it on Google Play"
            className="play-store-badge-app-not-available"
          />
        </a>
      </div>
    </div>
  );
};

export default AppNotAvailable;
